const withoutState = (url: string): string => url.split(/[?#]/)[0] ?? url

/**
 * Matched on a segment boundary, so `/risks` covers `/risks/detail/x` without also claiming
 * `/risk-alerts`. Query and fragment are dropped: a page holding state there is still that page.
 */
export const isRouteActive = (currentPath: string, href: string): boolean => {
  const path = withoutState(currentPath)
  const target = withoutState(href)

  return path === target || path.startsWith(`${target}/`)
}

export const isRouteExact = (currentPath: string, href: string): boolean => withoutState(currentPath) === withoutState(href)
